import { store } from 'components/App/components/UnauthenticatedApp';

// Check if the currently logged in user is a demo user
export function isDemoUser() {
  return hasOneOfRoles(['Docent Demo']);
}

// Check if the currently logged in user has one of the roles
export function hasOneOfRoles(roles) {
  // Get the roles of the authenticated user
  const userRoles = getRoles();

  // Cross check the role arrays to see if the user has the specified roles
  const filteredRoles = roles
    .map((role) => userRoles.find((userRole) => userRole === role))
    .filter((role) => role != null);

  // Return if the user has one of the roles
  return filteredRoles.length > 0;
}

// Get the roles of the user from the store
function getRoles() {
  const roles = store.getState().authentication.user?.roles || [];
  const roleNames = roles.map((role) => role.name);

  return roleNames || [];
}
